import React, { useState, useEffect } from "react";
import Navbar from "./navbar"


const About = (props) => {
    return <div className="font-mono mb-3 pb-4">
        <Navbar isAbout={true} loggedIn={props.loggedIn} setToken={props.setToken}/>
        <div id="about-screen" className="p-3 sm:p-1 h-screen grid grid-rows-6 justify-left max-w-lg m-auto">
            <div id="introduction" className="text-left row-start-2 row-span-2">
                <h1 className="about-title">About Bist</h1>
                    <div className="text-lg text-justify">
                        Bist was created in aim of building an efficient management system
                        of our readings. It will serve as a two-in-one electronic bookmark and 
                        journal to help you get more value out of your readings. 
                    </div>

            </div>
            <div id="created-by-wrapper" className="row-start-4 pb-4 mb-3">
                <h1 className="about-title">Created By</h1>
                <div className="grid grid-cols-1">
                    <div className="rounded-lg border-0 bg-red-200 w-11/12 justify-self-center">
                        <img className="rounded-lg border-0" src="https://fakeimg.pl/640x360"></img>
                        <div className="font-semibold p-3 text-xl text-white"> <a className="hover:text-gray-200 transition-all" href="https://jasch3n.github.io/mySite/index.html">Jasper Chen</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
}

export default About